import { render } from "./IncludeSections.vue?vue&type=template&id=1879f4c5"
import script from "./IncludeSections.vue?vue&type=script&lang=js"
export * from "./IncludeSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__